module.exports = __webpack_public_path__ + "img/home_banner3.3fd98727.png";